import { gql } from '@apollo/client';

export const GET_PRINT_PROVIDERS = gql`
  query PrintProviders {
    printProviders @rest(type: "Get Providers", path: "printprovider") {
      printProviderId
      name
      description: decription
      country
      address
      phoneNumber
      email
      website
      orderingSystems
      isEnabled
    }
  }
`;
